module.exports = __webpack_public_path__ + "static/media/rw-widgets.eceddf47.ttf";